export const SERVICES_LIST = [
  'Achat',
  'Comptabilité & Finance',
  'Ressources humaines',
  'Production',
  'Marketing',
  'Vente / Commercial',
  'Administratif',
  'Direction Générale',
  'Logistique',
  'Maintenance',
  'Environnement',
  'Santé',
  'Services Généraux',
  'Travaux',
  'Juridique',
  'Qualité Sécurité Environnement',
  'Fonction Publique',
  'Communication',
  "Bureau d'étude",
]

export const SERVICE_AUTRE_VALUE = 'Autre'
